<template>
  <v-list-item @click="onClickItemBusca">
		<v-list-item-avatar>
			<v-img v-if="item.urlLogo" :src="item.urlLogo">
				<template v-slot:placeholder>
					<v-progress-circular indeterminate color="grey"></v-progress-circular>
				</template>
			</v-img>
      <v-icon v-else v-text="'mdi-web'"/>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ item.nome }}</v-list-item-title>
    </v-list-item-content>
		<div v-if="typeof item.qtdIrmaos === 'number'">
			{{ item.qtdIrmaos }} IIr
		</div>
  </v-list-item>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { Potencia } from '../../common/types/Potencia'
import { useRouter } from '@/composables/router'

const props = defineProps({
	item: { type: Object as PropType<Potencia>, required: true },
})

const router = useRouter()

function onClickItemBusca() {
	router.push({
		name: 'detalhar-potencia',
		params: { id: props.item._id },
	})
}
</script>
